import { ConsumerNewsletter, useShowConsumerNewsletter } from '@givebacks/api/communication';
import { DateTime } from 'luxon';
import { useParams } from 'react-router-dom';
import { Container, Skeleton, Stack, Text, Title } from 'ui';

import PageNotFound from '../../components/PageNotFound';
import classes from './Newsletter.module.css';

const PreviewNewsletter = ({
  newsletter,
  isLoading,
}: {
  newsletter?: ConsumerNewsletter;
  isLoading: boolean;
}) => {
  if (isLoading) {
    return <Skeleton h={600} />;
  }

  if (!newsletter) {
    return null;
  }

  return (
    <iframe
      title="Email"
      width="100%"
      height="600px"
      srcDoc={newsletter.raw_html}
      style={{
        border: '0px',
        backgroundColor: '#f5f6f9',
        borderRadius: '8px',
        padding: 'var(--mantine-spacing-lg)',
      }}
    />
  );
};

const CommunicationNewsletter = () => {
  const { newsletterId } = useParams();
  const { data: newsletter, isLoading } = useShowConsumerNewsletter({ newsletterId });

  if (!newsletter && !isLoading) {
    return <PageNotFound />;
  }

  return (
    <Container size={'lg'} className={classes.container}>
      <Stack gap={'xl'}>
        <Stack gap={0} className={classes.header}>
          <Skeleton visible={isLoading} miw={40}>
            {newsletter && <Title order={1}>{newsletter.subject}</Title>}
          </Skeleton>
          <Skeleton visible={isLoading}>
            {newsletter && (
              <Text fz={14} fw={400} c="gray.6">
                Sent On: {DateTime.fromISO(newsletter?.sent_at).toFormat('MM/dd/yyyy')}
              </Text>
            )}
          </Skeleton>
        </Stack>

        <PreviewNewsletter newsletter={newsletter} isLoading={isLoading} />
      </Stack>
    </Container>
  );
};

export { CommunicationNewsletter };
